/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { TreeNode } from 'angular-tree-component';

/**
 * This is an extension of <code>tree-drop-slot</code> component which allows DnD in heteragenous environment.
 */
@Component({
  selector: 'gh-tree-node-dnd-drop-slot',
  template: require('./tree-node-dnd-drop-slot.component.html'),
})
export class TreeNodeDndDropSlotComponent {
  @Input() node: TreeNode;
  @Input() dropIndex: number;

  onDrop($event: any): void {
    this.node.mouseAction('drop', $event.event, {
      from: $event.element,
      to: { parent: this.node, index: this.dropIndex },
    });
  }

  allowDrop(element: any, $event: any): boolean {
    return this.node.options.allowDrop(element, { parent: this.node, index: this.dropIndex }, $event);
  }
}
